import classNames from "classnames";
import { Icon } from "components";
import { GRID, LIST } from "icons";
import { Button } from "ui/components/button";

export default function ViewToggle({ view, onViewChange }) {
  return (
    <div className="flex items-center gap-1 border border-border rounded-md p-1">
      <Button
        variant="ghost"
        size="sm"
        onClick={() => onViewChange("grid")}
        className={classNames(
          "h-8 px-3",
          view === "grid"
            ? "bg-primary text-primary-foreground"
            : "hover:bg-muted"
        )}
      >
        <Icon icon={GRID} className="size-4" />
      </Button>
      <Button
        variant="ghost"
        size="sm"
        onClick={() => onViewChange("list")}
        className={classNames(
          "h-8 px-3",
          view === "list"
            ? "bg-primary text-primary-foreground"
            : "hover:bg-muted"
        )}
      >
        <Icon icon={LIST} className="size-4" />
      </Button>
    </div>
  );
}
